import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
  AddRemoveButton,
  FlexRow,
  InputContainer,
  InputLabel,
  InputWrapper,
  RequiredLabel,
  SVGWrapper,
  Td,
  TdPrice,
  Tr
} from '../managedITServices/components/css';
import RemoveSVG from '../managedITServices/assets/svg/remove';
import AddSVG from '../managedITServices/assets/svg/add';
import { deleteOption } from '../managedITServices/components/saveSchemaToDB';

const SubscriptionLineOption = ({
  initialData,
  setInitialData,
  microsoftLicensingAdminData,
  setMicrosoftLicensingAdminData,
  subscriptionListItem,
  subscriptionListIndex,
  categoryIndex,
  isLast,
  isFirst,
  deleteOptions,
  setDeleteOptions,
}) => {
  const {
    name,
    productCatalogPricings: [{ cost, onetimePrice }],
    subscriptionId = '',
    subscriptionPlan = '',
    subscriptionItem = ''
  } = subscriptionListItem;

  const [lineOptionLabel, setLineOptionLabel] = useState(name);
  const [lineOptionCost, setLineOptionCost] = useState(cost);
  const [lineOptionPrice, setLineOptionPrice] = useState(onetimePrice);
  const [lineOptionId, setLineOptionId] = useState(subscriptionId);
  const [lineOptionPlan, setLineOptionPlan] = useState(subscriptionPlan);
  const [lineOptionItem, setLineOptionItem] = useState(subscriptionItem);

  const handleAddOption = () => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    const questionId = clonedAdminData[categoryIndex].id;
    clonedAdminData[categoryIndex].productCatalogOptions.push({
      questionId: questionId || '',
      id: '',
      name: '',
      subscriptionId: '',
      subscriptionPlan: '',
      subscriptionItem: '',
      productCatalogPricings: [
        {
          optionId: '',
          id: '',
          cost: 0,
          onetimePrice: 0,
          costPremium: 0,
          onetimePricePremium: 0,
          operationType: 'ADD'
        }
      ]
    });
    setMicrosoftLicensingAdminData(clonedAdminData);
  };

  const handleRemoveOption = async () => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    const optionId =
      clonedAdminData[categoryIndex].productCatalogOptions[
        subscriptionListIndex
      ].id;
    if (optionId) {
        setDeleteOptions(prevData=>[...prevData,optionId]);
    }
    clonedAdminData[categoryIndex].productCatalogOptions.splice(
      subscriptionListIndex,
      1
    );
    setMicrosoftLicensingAdminData(clonedAdminData);
  };

  const handleNameChange = () => {
    const clonedAdminData = JSON.parse(
      JSON.stringify(microsoftLicensingAdminData)
    );
    if (
      clonedAdminData[categoryIndex].productCatalogOptions &&
      clonedAdminData[categoryIndex].productCatalogOptions.length === 0
    ) {
      clonedAdminData[categoryIndex].productCatalogOptions.push(
        subscriptionListItem
      );
    }
    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].name = lineOptionLabel;

    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].subscriptionItem = lineOptionItem;
    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].subscriptionId = lineOptionId;
    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].subscriptionPlan = lineOptionPlan;

    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].productCatalogPricings[0].cost = lineOptionCost;
    clonedAdminData[categoryIndex].productCatalogOptions[
      subscriptionListIndex
    ].productCatalogPricings[0].onetimePrice = lineOptionPrice;
    setMicrosoftLicensingAdminData(clonedAdminData);
  };

  useEffect(() => {
    if(lineOptionLabel.trim())
        handleNameChange();
  }, [
    lineOptionLabel,
    lineOptionCost,
    lineOptionPrice,
    lineOptionId,
    lineOptionPlan,
    lineOptionItem
  ]);

  return (
    <>
      {isFirst ? (
        <>
          <Td>
            <input
              type="text"
              value={lineOptionLabel}
              style={{
                borderColor: lineOptionLabel ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setLineOptionLabel(e.target.value)}
            />
            {!lineOptionLabel && <RequiredLabel>Required</RequiredLabel>}
          </Td>

          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Subscription Id</InputLabel>
                <input
                  type="text"
                  value={lineOptionId}
                  style={{
                    borderColor: lineOptionId ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionId(e.target.value)}
                />
                {!lineOptionId && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Subscription Plan</InputLabel>
                <input
                  type="text"
                  value={lineOptionPlan}
                  style={{
                    borderColor: lineOptionPlan ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionPlan(e.target.value)}
                />
                {!lineOptionPlan && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Item</InputLabel>
                <input
                  type="text"
                  value={lineOptionItem}
                  style={{
                    borderColor: lineOptionItem ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionItem(e.target.value)}
                />
                {!lineOptionItem && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <FlexRow>
                <InputContainer>
                  <InputLabel>Cost</InputLabel>
                  <input
                    type="text"
                    value={lineOptionCost}
                    style={{
                      borderColor: lineOptionCost ? '#e4e4e4' : '#C12335'
                    }}
                    onChange={e => setLineOptionCost(e.target.value)}
                  />
                  {!lineOptionCost && <RequiredLabel>Required</RequiredLabel>}
                </InputContainer>
                <InputContainer>
                  <InputLabel>Price</InputLabel>
                  <input
                    type="text"
                    value={lineOptionPrice}
                    style={{
                      borderColor: lineOptionPrice ? '#e4e4e4' : '#C12335'
                    }}
                    onChange={e => setLineOptionPrice(e.target.value)}
                  />
                  {!lineOptionPrice && <RequiredLabel>Required</RequiredLabel>}
                </InputContainer>
              </FlexRow>
            </InputWrapper>
          </TdPrice>

          {/* <TdPrice>
                <input
                type="text"
                value={cost}
                style={{
                    borderColor: cost ? '#e4e4e4' : '#C12335'
                }}
                onChange={e => setLineOptionCost(e.target.value)}
                />
                {!cost && <RequiredLabel>Required</RequiredLabel>}
            </TdPrice> */}
          <TdPrice>
            {/* <input
              type="text"
              value={onetimePrice}
              style={{
                borderColor: onetimePrice ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setLineOptionPrice(e.target.value)}
            />
            {!onetimePrice && <RequiredLabel>Required</RequiredLabel>} */}
            <AddRemoveButton>
            {!isLast && (<SVGWrapper onClick={handleRemoveOption}>
                <RemoveSVG />
              </SVGWrapper>)}
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
            </AddRemoveButton>
          </TdPrice>
        </>
      ) : (
        <Tr>
          <Td></Td>
          <Td>
            <input
              type="text"
              value={lineOptionLabel}
              style={{
                borderColor: lineOptionLabel ? '#e4e4e4' : '#C12335'
              }}
              onChange={e => setLineOptionLabel(e.target.value)}
            />
            {!lineOptionLabel && <RequiredLabel>Required</RequiredLabel>}
          </Td>

          <TdPrice>
            <InputWrapper>
              <InputContainer>
                <InputLabel>Subscription Id</InputLabel>
                <input
                  type="text"
                  value={lineOptionId}
                  style={{
                    borderColor: lineOptionId ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionId(e.target.value)}
                />
                {!lineOptionId && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Subscription Plan</InputLabel>
                <input
                  type="text"
                  value={lineOptionPlan}
                  style={{
                    borderColor: lineOptionPlan ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionPlan(e.target.value)}
                />
                {!lineOptionPlan && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <InputContainer>
                <InputLabel>Item</InputLabel>
                <input
                  type="text"
                  value={lineOptionItem}
                  style={{
                    borderColor: lineOptionItem ? '#e4e4e4' : '#C12335'
                  }}
                  onChange={e => setLineOptionItem(e.target.value)}
                />
                {!lineOptionItem && <RequiredLabel>Required</RequiredLabel>}
              </InputContainer>
              <FlexRow>
                <InputContainer>
                  <InputLabel>Cost</InputLabel>
                  <input
                    type="text"
                    value={lineOptionCost}
                    style={{
                      borderColor: lineOptionCost ? '#e4e4e4' : '#C12335'
                    }}
                    onChange={e => setLineOptionCost(e.target.value)}
                  />
                  {!lineOptionCost && <RequiredLabel>Required</RequiredLabel>}
                </InputContainer>
                <InputContainer>
                  <InputLabel>Price</InputLabel>
                  <input
                    type="text"
                    value={lineOptionPrice}
                    style={{
                      borderColor: lineOptionPrice ? '#e4e4e4' : '#C12335'
                    }}
                    onChange={e => setLineOptionPrice(e.target.value)}
                  />
                  {!lineOptionPrice && <RequiredLabel>Required</RequiredLabel>}
                </InputContainer>
              </FlexRow>
            </InputWrapper>
          </TdPrice>

          <TdPrice>
            <AddRemoveButton>
              <SVGWrapper onClick={handleRemoveOption}>
                <RemoveSVG />
              </SVGWrapper>
              {isLast && (
                <SVGWrapper onClick={handleAddOption}>
                  <AddSVG />
                </SVGWrapper>
              )}
            </AddRemoveButton>
          </TdPrice>
        </Tr>
      )}
    </>
  );
};

export default SubscriptionLineOption;
